<template>
  <div>
    <AddressBookTable :company-id="companyId" :title="customerName" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useCustomersStore } from '@/store/customers'
import AddressBookTable from '@/views/Components/AddressBook/AddressBookTable.vue'

export default defineComponent({
  name: 'StaffAddressBookPage',
  components: { AddressBookTable },
  setup() {
    const route = useRoute()
    const customersStore = useCustomersStore()

    const companyId = computed(() => route.params.companyId as string)
    const customerName = computed(() => customersStore.customer?.name || '')

    watch(companyId, (id) => customersStore.fetch(id), { immediate: true })

    return { companyId, customerName }
  },
})
</script>
